import styled from "styled-components";

export const StyledH4 = styled("h4")`
    font-weight: 600;
    line-height: 1.5em;
`